angular.module('app-ui-profile').service('profileService', [
  'rcmApiLibService',
  'rcmLoading',
  'rcmEventManager',
  function (rcmApiLibService, rcmLoading, rcmEventManager) {
    const self = this;

    const urls = {
      profile: '/api/checkout/profile/current',
    };

    /**
     * onApiSuccess
     *
     * @param response
     * @param success
     */
    const onApiSuccess = function (response, success) {
      if (typeof success === 'function') {
        success(response);
      }
    };

    /**
     * onApiError
     *
     * @param response
     * @param error
     */
    const onApiError = function (response, error) {
      if (typeof error === 'function') {
        error(response);
      }
    };

    /**
     * getEventManager
     *
     * @returns {rcmEventManager|*}
     */
    self.getEventManager = function () {
      return rcmEventManager;
    };

    /**
     * getCurrentProfile
     *
     * @param success
     * @param error
     */
    self.getCurrentProfile = function (success, error) {
      rcmApiLibService.get({
        url: urls.profile,
        urlParams: { id: 'current' },
        loading: function (loading) {
          const loadingInt = Number(!loading);
          rcmLoading.setLoading('profileService.getCurrentProfile.loading', loadingInt);
          rcmEventManager.trigger('profileService.loading', loading);
        },
        success: function (response) {
          rcmEventManager.trigger('profileService.getCurrentProfile.success', response);
          onApiSuccess(response, success);
        },
        error: function (response) {
          rcmEventManager.trigger('profileService.getCurrentProfile.error', response);
          onApiError(response, error);
        },
      });
    };

    /**
     * getProfile
     *
     * @param id
     * @param success
     * @param error
     */
    self.getProfile = function (id, success, error) {
      rcmApiLibService.get({
        url: urls.profile,
        urlParams: { id: id },
        loading: function (loading) {
          const loadingInt = Number(!loading);
          rcmLoading.setLoading('profileService.getProfile.loading', loadingInt);
          rcmEventManager.trigger('profileService.loading', loading);
        },
        success: function (response) {
          rcmEventManager.trigger('profileService.getProfile.success', response);
          onApiSuccess(response, success);
        },
        error: function (response) {
          rcmEventManager.trigger('profileService.getProfile.error', response);
          onApiError(response, error);
        },
      });
    };

    /**
     * updateProfile
     *
     * @param profile
     * @param success
     * @param error
     */
    self.updateProfile = function (profile, success, error) {
      rcmApiLibService.put({
        url: urls.profile,
        urlParams: { id: profile.rcn },
        data: profile,
        loading: function (loading) {
          const loadingInt = Number(!loading);
          rcmLoading.setLoading('profileService.updateProfile.loading', loadingInt);
          rcmEventManager.trigger('profileService.loading', loading);
        },
        success: function (response) {
          rcmEventManager.trigger('profileService.updateProfile.success', response);
          onApiSuccess(response, success);
        },
        error: function (response) {
          rcmEventManager.trigger('profileService.updateProfile.error', response);
          onApiError(response, error);
        },
      });
    };

    /**
     * createProfile
     *
     * @param profile
     * @param success
     * @param error
     */
    self.createProfile = function (profile, success, error) {
      rcmApiLibService.post({
        url: urls.profile,
        urlParams: { id: null },
        data: profile,
        loading: function (loading) {
          const loadingInt = Number(!loading);
          rcmLoading.setLoading('profileService.createProfile.loading', loadingInt);
          rcmEventManager.trigger('profileService.loading', loading);
        },
        success: function (response) {
          rcmEventManager.trigger('profileService.createProfile.success', response);
          onApiSuccess(response, success);
        },
        error: function (response) {
          rcmEventManager.trigger('profileService.createProfile.error', response);
          onApiError(response, error);
        },
      });
    };
  },
]);
